/** Генерируется автоматически с помощью EnvconfigPlugin */
import { createEnvVar } from '@alfa-bank/site-envconfig-utils/helpers';

export const INVEST_ALFADIRECT_FORM = createEnvVar(
    'INVEST_ALFADIRECT_FORM',
    process.env.INVEST_ALFADIRECT_FORM
);
export const INVEST_ANKETA_FORM = createEnvVar(
    'INVEST_ANKETA_FORM',
    process.env.INVEST_ANKETA_FORM
);
export const INVEST_CYCLOPEDIA = createEnvVar('INVEST_CYCLOPEDIA', process.env.INVEST_CYCLOPEDIA);
export const INVEST_EMITENTS_GRAPHQL_API = createEnvVar(
    'INVEST_EMITENTS_GRAPHQL_API',
    process.env.INVEST_EMITENTS_GRAPHQL_API
);
export const INVEST_MARGIN_TRADING = createEnvVar(
    'INVEST_MARGIN_TRADING',
    process.env.INVEST_MARGIN_TRADING
);
export const INVEST_MEDIAPORTAL = createEnvVar(
    'INVEST_MEDIAPORTAL',
    process.env.INVEST_MEDIAPORTAL
);
export const INVEST_PORTAL = createEnvVar('INVEST_PORTAL', process.env.INVEST_PORTAL);
export const INVEST_PRESS_NEWS = createEnvVar('INVEST_PRESS_NEWS', process.env.INVEST_PRESS_NEWS);
export const INVEST_SCROOGE_ALFA_RATES = createEnvVar(
    'INVEST_SCROOGE_ALFA_RATES',
    process.env.INVEST_SCROOGE_ALFA_RATES
);
export const INVEST_SCROOGE_STOCK_EXCHANGE = createEnvVar(
    'INVEST_SCROOGE_STOCK_EXCHANGE',
    process.env.INVEST_SCROOGE_STOCK_EXCHANGE
);
export const INVEST_SMEV_APPLICATIONS = createEnvVar(
    'INVEST_SMEV_APPLICATIONS',
    process.env.INVEST_SMEV_APPLICATIONS
);
export const INVEST_TRANBILOG = createEnvVar('INVEST_TRANBILOG', process.env.INVEST_TRANBILOG);
export const INVEST_VTB_APPLICATIONS = createEnvVar(
    'INVEST_VTB_APPLICATIONS',
    process.env.INVEST_VTB_APPLICATIONS
);
